/**
 * 将一段线段墙（grid 坐标 from→to）转换为世界坐标下的盒子 { cx, cz, sx, sz }。
 *
 * grid → world 映射：
 *   wx = gx - PANEL_SIZE/2
 *   wz = PANEL_SIZE/2 - gy     （z 反向）
 *
 * 为了让两段墙在 L 形 / T 形接头处不出现 t×t 缺角（各自中心对齐线段，端点
 * 只到 "墙中线" 位置），这里把盒子在两端各向外延伸 t/2，使端点落在 "墙外缘"。
 * 相邻墙段因此会在交点处互相重叠 t×t，拼成完整的角。
 *
 * 对于 from == to 的退化段，生成 t×t 的方块（不会出现在当前生成器输出里，但稳妥处理）。
 *
 * @param {{from:[number,number], to:[number,number]}} wall
 * @param {number} panelSize  PANEL_SIZE
 * @param {number} t          WALL_THICKNESS
 * @returns {{cx:number, cz:number, sx:number, sz:number}}
 */
export function wallSegmentBox(wall, panelSize, t) {
  const half = panelSize / 2;
  const [fx, fy] = wall.from;
  const [tx, ty] = wall.to;
  const wx1 = fx - half;
  const wz1 = half - fy;
  const wx2 = tx - half;
  const wz2 = half - ty;

  const dx = wx2 - wx1;
  const dz = wz2 - wz1;
  const cx = (wx1 + wx2) / 2;
  const cz = (wz1 + wz2) / 2;

  // 水平向尺寸：沿 x 轴有延展时长度 = |dx| + t，否则为 t
  const sx = Math.abs(dx) > 0 ? Math.abs(dx) + t : t;
  const sz = Math.abs(dz) > 0 ? Math.abs(dz) + t : t;
  return { cx, cz, sx, sz };
}
